var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-view"},[_c('NavBar'),_c('feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }